import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { EntityService } from '../../services/entity.service';
import { EntityEditComponent } from '../entity-edit/entity-edit.component';
import { NoteService } from "../../services/note.service";
import { transferColorRgba } from '../../services/util.service'

@Component({
  selector: 'app-sl-view-new',
  templateUrl: './sl-view-new.component.html',
  styleUrls: ['./sl-view-new.component.scss']
})
export class SlViewNewComponent implements OnInit,OnChanges {

  @Input() showEditable=false;
  @Input() entitiesData;
  @Input() sAccount;
  @Input() sVersion;
  @Input() healthHideEntities;
  @Input() entityViewType;
  @Input() pageView = 0;
  @Input() stackColors = [];

  // how many vertical blocks each section has
  // recalced to handle overflows
  row1vblocks=1;
  row2vblocks=1;
  row3vblocks=1;
  row4vblocks=1;
  row5vblocks=1;
  row6vblocks=1;

  col1vblocks=2;
  col2vblocks=2;
  col3vblocks=2;
  col4vblocks=2;

  areaCounts=[];

  avgRowHeight = 132;
  avgEntityHeight = 127;

  entityData = {
    bps: {
      area: ['bps','bpaas','insurance'],
      data: [],
      bgName: 'Ins/BPaaS/BPO',
      bgColor: '',
      defaultSize: 2
    },
    consulting: {
      area: ['consulting'],
      data: [],
      bgName: 'Advisory',
      bgColor: '',
      defaultSize: 2
    },
    analysts: {
      area: ['analysts'],
      data: [],
      bgName: 'Advisory',
      bgColor: '',
      defaultSize: 2
    },
    engineering: {
      area: ['engineering'],
      data: [],
      bgName: 'Engineering',
      bgColor: '',
      defaultSize: 2
    },
    analytics: {
      area: ['analytics'],
      data: [],
      bgName: 'Analytics',
      bgColor: '',
      defaultSize: 2
    },
    data: {
      area: ['data'],
      data: [],
      bgName: 'Data Services',
      bgColor: '',
      defaultSize: 2
    },
    managedapp: {
      area: ['managedapp'],
      data: [],
      bgName: 'Applications',
      bgColor: '',
      defaultSize: 2
    },
    enterpriseapp: {
      area: ['enterpriseapp'],
      data: [],
      bgName: 'Applications',
      bgColor: '',
      defaultSize: 2
    },
    modernization: {
      area: ['modernization'],
      data: [],
      bgName: 'Applications',
      bgColor: '',
      defaultSize: 2
    },
    iaas: {
      area: ['iaas'],
      data: [],
      bgName: 'Cloud',
      bgColor: '',
      defaultSize: 2
    },
    paas: {
      area: ['paas'],
      data: [],
      bgName: 'Cloud',
      bgColor: '',
      defaultSize: 2
    },
    hybrid: {
      area: ['hybrid'],
      data: [],
      bgName: 'Cloud',
      bgColor: '',
      defaultSize: 2
    },
    server: {
      area: ['server'],
      data: [],
      bgName: 'Infrastructure',
      bgColor: '',
      defaultSize: 2
    },
    mainframe: {
      area: ['mainframe'],
      data: [],
      bgName: 'Infrastructure',
      bgColor: '',
      defaultSize: 1
    },
    storage: {
      area: ['storage'],
      data: [],
      bgName: 'Infrastructure',
      bgColor: '',
      defaultSize: 2
    },
    devices: {
      area: ['devices'],
      data: [],
      bgName: 'Workplace',
      bgColor: '',
      defaultSize: 2
    },
    collaboration: {
      area: ['collaboration'],
      data: [],
      bgName: 'Workplace',
      bgColor: '',
      defaultSize: 2
    },
    asset: {
      area: ['asset'],
      data: [],
      bgName: 'Workplace',
      bgColor: '',
      defaultSize: 1
    },
    network: {
      area: ['network'],
      data: [],
      bgName: 'Infrastructure',
      bgColor: '',
      defaultSize: 2
    },
    systemsupport: {
      area: ['systemsupport'],
      data: [],
      bgName: 'System Support',
      bgColor: '',
      defaultSize: 2
    },
    security: {
      area: ['security'],
      data: [],
      bgName: 'Security',
      bgColor: '',
      defaultSize: 2
    },
    datacenter: {
      area: ['datacenter'],
      data: [],
      bgName: 'Infrastructure',
      bgColor: '',
      defaultSize: 2
    },
  };

  rowAreaHeight = {
    row1: {
      areaHeight: ''
    },
    row2: {
      areaHeight: ''
    },
    row3: {
      areaHeight: ''
    },
    row4: {
      areaHeight: ''
    },
    row5: {
      areaHeight: ''
    },
    row6: {
      areaHeight: ''
    }
  };

  constructor(
    public entityService: EntityService,
    public dialog: MatDialog,
    public noteService:NoteService,
  ) { }

  ngOnInit(): void {
    this.getHeights();
  }

  ngOnChanges(){
    this.getHeights();
  }

  getEntity(areaKey){

    if(!this.entitiesData || !this.entityData[areaKey]) return [];
    
    let { area, defaultSize } = this.entityData[areaKey];

    // if its not an array then turn it into one
    if(!Array.isArray(area)) area = [area];

    // if this is the health view then only show enities with a health status
    // if the checkbox is ticked
    let rtn = [];

    // step through each area in turn to peserve the area order passed
    area.forEach(a => {
      if (this.pageView === 1 || this.pageView === 2) {
        let items = [];
        if (this.entityViewType === 'health' && this.healthHideEntities) {
          items = [...this.entitiesData.filter(x => (x.area.toLowerCase() == a && (x.healthstatus!="" && x.healthstatus!=null))).sort((x, y) => parseInt(x.displayorder) > parseInt(y.displayorder) ? 1 : -1)];
        } else {
          items = [...this.entitiesData.filter(x => (x.area.toLowerCase() == a)).sort((x, y) => parseInt(x.displayorder) > parseInt(y.displayorder) ? 1 : -1)];
        }

        if (defaultSize) {
          if (rtn.length < defaultSize) {
            rtn.push(...items.slice(0, defaultSize - rtn.length));
          }
        } else {
          rtn.push(...items);
        }
      } else {
        if (this.entityViewType === 'health' && this.healthHideEntities) {
          rtn.push(...this.entitiesData.filter(x => (x.area.toLowerCase() == a && (x.healthstatus!="" && x.healthstatus!=null))).sort((x, y) => parseInt(x.displayorder) > parseInt(y.displayorder) ? 1 : -1))
        } else {
          rtn.push(...this.entitiesData.filter(x => (x.area.toLowerCase() == a)).sort((x, y) => parseInt(x.displayorder) > parseInt(y.displayorder) ? 1 : -1))
        }
      }
    });
    //rtn.sort((x, y) => (parseInt(x.displayorder) > parseInt(y.displayorder)) ? 1 : -1);
    // console.log(rtn);
    return rtn;
  }

  getTotalRows(){
    let x= 0;
    x+= this.row1vblocks
    x+= this.row2vblocks
    x+= this.row3vblocks
    x+= this.row4vblocks
    x+= this.row5vblocks
    x+= this.row6vblocks
    return x
  }

  getAreaHeight(x){
    return ((x * this.avgEntityHeight) + 20) + "px";
  }

  getColAreaHeight(rowsData: any[]) {
    let height = 0;
    if (Array.isArray(rowsData) && rowsData.length) {
      rowsData.forEach(rows => {
        height = height + ((rows * this.avgEntityHeight) + 20);
      });
      height = height + ((rowsData.length - 1) * 20);
    }
    return `${height}px`;
  }

  getC1Height(){
    return this.getColAreaHeight([this.row5vblocks, this.row6vblocks]);
  }

  getC2Height(){
    return this.getColAreaHeight([this.row1vblocks, this.row2vblocks]);
  }

  getC3Height(){
    return this.getColAreaHeight([this.row3vblocks, this.row4vblocks]);
  }

  getC4Height(){
    return this.getColAreaHeight([this.row5vblocks, this.row6vblocks]);
  }

  public addEntity(){
    this.openEntityEdit({});
  }

  // handle expanding the rows if we have more entities than will fit
  getHeights(){
    for (const [key, value] of Object.entries(this.entityData)) {
      this.entityData[key].data = this.getEntity(key);
      this.entityData[key].bgColor = this.getBackgroundColor(value.bgName);
    }

    // bps has 2 slots, consulting 2 slots and analysts 2 slots
    let r1 = Math.max(2,this.entityData.bps.data.length,this.entityData.consulting.data.length,this.entityData.analysts.data.length);
    this.row1vblocks = Math.ceil(r1/2);

    // engineering has 2 slosts, analytics has 2 slots, data has 2 blocks
    let r2 = Math.max(1,this.entityData.engineering.data.length/2,this.entityData.analytics.data.length/2,this.entityData.data.data.length/2)
    this.row2vblocks = Math.ceil(r2);

    // managedapp, enterpriseapp, modernization all have 2 slots
    let r3 = Math.max(2,this.entityData.managedapp.data.length,this.entityData.enterpriseapp.data.length,this.entityData.modernization.data.length);
    this.row3vblocks = Math.ceil(r3/2);

    // iaas has 2 slots, paas has 2 slots, hybrid has 2 blocks
    let r4 = Math.max(1,this.entityData.iaas.data.length/2,this.entityData.paas.data.length/2,this.entityData.hybrid.data.length/2)
    this.row4vblocks = Math.ceil(r4);

    // server has 2, mainframe 1, storage 2
    let r5 = Math.max(1,this.entityData.server.data.length/2,this.entityData.mainframe.data.length,this.entityData.storage.data.length/2)
    this.row5vblocks = Math.ceil(r5);

    // devices has 2, collaboration 2, asset 1
    let r6 = Math.max(1,this.entityData.devices.data.length/2,this.entityData.collaboration.data.length/2,this.entityData.asset.data.length);
    this.row6vblocks = Math.ceil(r6);

    // network has r5+r6 slots - if it is more than 2 then make the bottom row bigger to match if required
    let slots = (this.row5vblocks+this.row6vblocks)
    this.col1vblocks = this.entityData.network.data.length
    if(this.col1vblocks>slots){
      this.row6vblocks = this.col1vblocks - this.row5vblocks - 0.5;
    } else {
      this.col1vblocks = slots;
    }

    // system support has (r1+r2) slots - if its more than 2 then make row2 bigger if required
    slots = (this.row1vblocks+this.row2vblocks)
    this.col2vblocks = this.entityData.systemsupport.data.length
    if(this.col2vblocks>slots){
        this.row2vblocks = this.col2vblocks - this.row1vblocks - 0.5;
    } else {
      this.col2vblocks = slots;
    }

    // security has (r3+r4) slots - if it is more than 2 then make row4 bigger (if required)
    slots = (this.row3vblocks+this.row4vblocks)
    this.col3vblocks = this.entityData.security.data.length
    if(this.col3vblocks>slots){
        this.row4vblocks = this.col3vblocks - this.row3vblocks - 0.5;
    } else {
      this.col3vblocks = slots;
    }

    // system support has (r5+r6) slots - if its more than 2 then make row6 bigger if required
    slots = (this.row5vblocks+this.row6vblocks)
    this.col4vblocks = this.entityData.datacenter.data.length
    if(this.col4vblocks>slots){
        this.row6vblocks = this.col4vblocks - this.row5vblocks - 0.5;
        // adjust network size as well if we increase the size
        this.col1vblocks = this.col4vblocks
    } else {
      this.col4vblocks = slots;
    }

    Object.keys(this.rowAreaHeight).forEach(row => {
      const blockField = `${row}vblocks`;
      this.rowAreaHeight[row].areaHeight = this.getAreaHeight(this[blockField]);
    });
  }

  editEntity(id){
    // find the data row and pass to the edit
    const d = this.entitiesData.filter(x => (x.id == id))
    if(d.length==1) this.openEntityEdit(d[0]);
  }

  openEntityEdit(data){

    if(!this.showEditable) return false;

    let newdata = this.deepCopy(data);
    newdata["selectedTab"] = (this.getEntityViewType() == 'landscape' ? 0 : 1 );
    newdata["entitiesData"] = this.entitiesData;
    newdata["sAccount"] = this.sAccount;
    newdata["sVersion"] = this.sVersion;

    // pass the count of Entities in each area so it knows what to show in the order drop down
    let areaCounts = {};
    this.entitiesData.forEach(x => {
      if(areaCounts[x.area] == null ) {
        areaCounts[x.area]=1;
      } else {
        areaCounts[x.area]=areaCounts[x.area]+1;
      }
    });

    newdata["areaCounts"] = areaCounts;
    newdata['useNewLayout'] = true;

    let dialogRef = this.dialog.open(EntityEditComponent, {
      height: '630px',
      width: '700px',
      data: newdata
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result=="cancel"){

      } else if(result=="delete"){

        // delete from the database
        this.entityService.deleteEntity(newdata);

        // update the order list for this area - just update in order - don't need to save in the database
        // cause the order hasn't actually changed
        let cnt = 1;
        this.entitiesData.sort((x, y) => (x.displayorder > y.displayorder) ? 1 : -1).forEach((x) => {
          if(x.area == newdata["area"]){
            if(x.id != newdata["id"]){
              this.entityService.updateEntitySortOrder(x.id,cnt);
              cnt++;
            }
          }
        });



      } else if(result!=undefined){
        let slNewNote = result['slNewNote'];
        let hvNewNote = result['hvNewNote'];
        let geNewNote = result['geNewNote'];
        if(result["slNewNote"]) delete result["slNewNote"]; 
        if(result["hvNewNote"]) delete result["hvNewNote"];
        if(result["geNewNote"]) delete result["geNewNote"];

        // add in the account and the version
        result["accountid"] = this.sAccount["id"];
        result["versionid"] = this.sVersion;

        // save to the database
        this.entityService.updateEntity(result).then(
          (res:object) => { 
            if(slNewNote){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'landscape',
                'comment': slNewNote
              });
            }
            if(hvNewNote){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'health',
                'comment': hvNewNote
              });
            }
            if(geNewNote){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'general',
                'comment': geNewNote
              });
            }
          },
          (err) => { alert(err);}
        );

        // redo the order list for this area - remember the vals so we can save
        let updateSort = [];
        let cnt = 1;
        let newdo = result["displayorder"];
        let originaldo = result["originalDisplayOrder"]!=undefined ? result["originalDisplayOrder"] : 9999 ;
        // console.log("newdo:" + newdo + " originaldo:" + originaldo)
        this.entitiesData.sort((x, y) => (x.displayorder > y.displayorder) ? 1 : -1).forEach((x) => {
          if(x.area == result["area"]){
            if(x.id != result["id"]){
              if(x.displayorder < originaldo && x.displayorder >= newdo){
                // console.log("--udpate " + x.servicename + " to:" + ((+x.displayorder) + 1))
                x.displayorder = (+x.displayorder) + 1
                this.entityService.updateEntitySortOrder(x.id,x.displayorder);
                updateSort.push({accountid:this.sAccount["id"],versionid:this.sVersion,id:x["id"],displayorder:x.displayorder})
              } else if (x.displayorder > originaldo && x.displayorder <= newdo) {
                // console.log("--udpate " + x.servicename + " to:" + ((+x.displayorder) - 1))
                x.displayorder = (+x.displayorder) - 1
                this.entityService.updateEntitySortOrder(x.id,x.displayorder);
                updateSort.push({accountid:this.sAccount["id"],versionid:this.sVersion,id:x["id"],displayorder:x.displayorder})
              }
            }
          }
        });

        if(updateSort.length>0){
          this.entityService.updateEntitySort(updateSort);
        }

      }
    })
  }



    // what is the entity type - depends on page
    getEntityViewType(){
      return this.entityViewType;
    }

      // deep copy of Object
      private deepCopy(obj) {
        return Object.keys(obj).reduce((v, d) => Object.assign(v, {
          [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
        }), {});
      }

  getBackgroundColor(stack: string) {
    let color = '#5f249f';
    const colorItem = this.stackColors.find(item => item.name === stack);
    if (colorItem && colorItem.color) {
      color = colorItem.color;
    }
    return transferColorRgba(color, 0.5);
  }
}
